/* eslint-disable */
import { combineReducers } from 'redux';

// Constants Types
import {
  PATIENT_CONNECTION_INFO_REQUEST,
  PATIENT_CONNECTION_INFO_SUCCESS,
  PATIENT_CONNECTION_INFO_FAILURE,
} from './types';

const initialState = {
  isRequesting: false,
  data: {},
  error: {},
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PATIENT_CONNECTION_INFO_REQUEST]: (state, action) => ({
    ...state,
    isRequesting: true,
  }),
  [PATIENT_CONNECTION_INFO_SUCCESS]: (state, action) => ({
    ...state,
    isRequesting: false,
    data: action.payload,
  }),
  [PATIENT_CONNECTION_INFO_FAILURE]: (state, action) => ({
    ...state,
    isRequesting: false,
    error: action.payload,
  }),
};

//
// Reducer
// ------------------------------------
const PatientConnectionInfo = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};

export default combineReducers({
  patientConnectionInfo: PatientConnectionInfo,
});



// WEBPACK FOOTER //
// ./src/views/state/PatientConnectionInfo/PatientConnectionInfoReducers.js